import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import LoginButton from '../LoginButton/LoginButton';
import './MenuBar.scss';

const NAV_LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/daily', label: 'Daily' },
  { to: '/leaderboard', label: 'Leaderboard' },
  { to: '/credits', label: 'Credits' },
];

const MenuBar = () => {
  return (
    <nav className="menu-bar">
      <div className="menu-bar__brand">
        <Link to="/" className="menu-bar__brand-link" aria-label="GuessNexus home">
          <img
            src="/logo-transparent.png"
            alt=""
            className="menu-bar__brand-logo"
            width={32}
            height={32}
            draggable={false}
          />
          <span className="menu-bar__brand-text">GUESS NEXUS</span>
        </Link>
      </div>

      <ul className="menu-bar__links">
        {NAV_LINKS.map(({ to, label, end }) => (
          <li key={to} className="menu-bar__item">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                `menu-bar__link${isActive ? ' menu-bar__link--active' : ''}`
              }
            >
              {label}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="menu-bar__auth">
        <LoginButton />
      </div>
    </nav>
  );
};

export default MenuBar;
